module.exports = __webpack_public_path__ + "img/mj8-heating.93b68f97.png";